var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',{attrs:{"title":"我是待办清单 请输入您的Todo..."}},[_vm._v(_vm._s(_vm.title))]),_c('TodoButton',{staticClass:"btn",attrs:{"text":_vm.showAdd ? 'Close' : 'Add Todo',"color":_vm.showAdd ? 'red' : 'black',"title":_vm.showAdd ? '点我关闭' : '点我展开'},on:{"toggle-add-task":function($event){return _vm.$emit('toggle-add-task')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }